import React, { useEffect, useState } from "react";
import { call_icon } from "../icons/call";
import { exit_icon } from "../icons/exit";
import contact from "../images/contacts.png";
import { copy_icon } from "../icons/copy";
import Client from "../utils/client";
import { useAuth } from "../store/authProvider";

const ContactModal = ({ offer, setShowContactModal }) => {
  const { isAuth } = useAuth();
  const [copy, setCopy] = useState(true);
  return (
    <>
      <div className="fixed inset-0 z-50 flex items-center justify-center overflow-x-hidden overflow-y-auto outline-none focus:outline-none">
        <div className="relative max-w-3xl w-[350px] mx-auto my-6">
          <div className="relative flex flex-col w-full bg-white border-[3px] border-primary rounded-3xl shadow-lg outline-none focus:outline-none h-[260px] p-3">
            <div
              className="text-red-600 w-8"
              onClick={() => setShowContactModal(false)}
            >
              {exit_icon}
            </div>
            <div className="w-full flex justify-center items-center mt-5 gap-3">
              <p className="font-bold">رقم التواصل</p>
              <img src={contact} className="w-10" alt="" />
            </div>
            <div className="h-5"></div>
            <div className="w-full h-12 border-[1px] border-gray-500 rounded-xl flex items-center px-2 justify-between">
              {offer.user.phonenumber}
              <div className="flex flex-row-reverse gap-4">
                <a href={`tel:${offer.user.phonenumber}`}>{call_icon}</a>
                <button
                  onClick={() => {
                    navigator.clipboard.writeText(`${offer.user.phonenumber}`);
                    setCopy(false);
                  }}
                >
                  {copy === true && <span>{copy_icon}</span>}
                  {copy === false && (
                    <span dir="rtl" className="text-primary ">
                      تم النسخ !
                    </span>
                  )}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="fixed inset-0 z-40 bg-black/30 backdrop-blur-sm"></div>
    </>
  );
};

export default ContactModal;
